<template>
  <v-dialog width="1000px" v-model="newPromotion" persistent>
    <v-card class="pa-4">
      <v-flex class="row mx-3 my-2">
        <v-layout align-center>
          <span class="title font-weight-medium">Nova Oferta</span>
          <v-spacer></v-spacer>
          <v-btn icon class="ma-0" @click="$emit('close'), clear()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
      <v-divider></v-divider>
      <v-progress-circular
        rotate="-90"
        size="50"
        :width="10"
        :value="value"
        color="blue darken-2"
        class="ml-2"
      ></v-progress-circular>

      <!-- Primeira etapa -->
      <span class="subheading font-weight-medium pl-4" v-if="value == 1"
        >Etapa {{ currentStep }} de {{ steps }} - Dados da Oferta</span
      >

      <v-layout class="mx-1" row wrap v-if="value == 1">
        <v-form class="row" ref="form" v-model="valid">
          <v-flex md6 xs12>
            <v-text-field
              v-model="promotion.name"
              class="mx-3"
              maxlength="30"
              counter
              :rules="[rules.required]"
              label="Título"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs12 class="pt-3">
            <span
              class="subheading grey--text text--darken-1 mx-3"
              for="url_img"
              v-if="!inputImageAlert"
              >Tipo da Oferta:</span
            >
            <v-radio-group
              @change="setSteps()"
              hide-details
              v-model="promotion.type"
              class="mt-2 mx-3"
            >
              <v-radio
                label="Pacotes"
                value="package"
                class="radio-row"
              ></v-radio>
              <!-- <v-radio label="Pacote Horas" value="wallet_hours"></v-radio> -->
              <v-radio
                label="Assinatura (Recorrencia)"
                value="recurrent"
                class="radio-row"
              ></v-radio>
              <v-radio
                label="Fidelidade (Recorrencia)"
                value="loyalty"
                class="radio-row"
              ></v-radio>
              <!-- <v-radio label="Promoção" value="promotion"></v-radio>
              <v-radio label="Banner Informativo" value="banner"></v-radio> -->
            </v-radio-group>
          </v-flex>
          <v-flex md8 xs8 v-if="promotion.type != 'loyalty'">
            <v-select
              v-model="promotion.vehicles_model_category"
              :items="category"
              item-text="name"
              item-value="id"
              label="Categoria do Veículo"
              required
              style="margin-left: 12px; margin-right: 12px"
            ></v-select>
          </v-flex>
          <v-flex md8 xs8 v-if="promotion.type == 'loyalty'">
            <v-select
              v-model="promotion.discount_type_id"
              :items="discountsTypes"
              item-text="title"
              item-value="id"
              label="Tipo de Fidelidade"
              required
              style="margin-left: 12px; margin-right: 12px"
            ></v-select>
          </v-flex>
          <v-flex md4 xs4 v-if="promotion.type != 'loyalty'">
            <v-text-field
              v-model="promotion.order"
              class="mx-3"
              label="Ordem"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs12>
            <v-textarea
              v-if="promotion.type != 'banner'"
              v-model="promotion.sub_title"
              class="mx-3"
              maxlength="250"
              counter
              rows="4"
              :rules="[rules.required, rules.counterDescription]"
              label="Descrição"
              no-resize
            ></v-textarea>
          </v-flex>
          <v-flex md6 xs12>
            <v-textarea
              v-if="promotion.type != 'banner'"
              v-model="promotion.description"
              class="mx-3"
              label="Termo de Uso"
              rows="4"
              :rules="[rules.required]"
              no-resize
            ></v-textarea>
          </v-flex>
          <v-flex md6 xs12>
            <v-menu
              v-model="promotion.menuInicio"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="promotion.start_date"
                  label="Data Início da Venda"
                  class="mx-3"
                  readonly
                  v-on="on"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="promotion.start_date"
                @input="menuInicio = false"
                locale="pt-br"
                :min="dateNow()"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md6 xs12>
            <v-menu
              v-model="menuFim"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="promotion.end_date"
                  label="Data Fim da Venda"
                  class="mx-3"
                  readonly
                  v-on="on"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="promotion.end_date"
                @input="menuFim = false"
                locale="pt-br"
                :min="dateNow()"
              >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex v-if="promotion.type == 'wallet_hours'" md12 xs12>
            <v-text-field
              v-model="promotion.expiry_time"
              class="mx-3"
              maxlength="20"
              v-mask="'###'"
              counter
              :rules="[
                v => !!v || 'Campo obrigatório!',
                v => v >= 0 || 'Valor inválido!',
              ]"
              label="Tempo de validade (Em dias)"
            ></v-text-field>
          </v-flex>
          <v-flex
            v-if="promotion.type == 'promotion' || promotion.type == 'package'"
            md12
            xs12
          >
            <v-text-field
              v-model="promotion.max_free_km"
              class="mx-3"
              maxlength="3"
              v-mask="'###'"
              :rules="[
                v => !!v || 'Campo obrigatório!',
                v => v >= 0 || 'Valor inválido!',
              ]"
              counter
              label="Max Free KM (Em KM)"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs12 class="pt-3">
            <span
              class="subheading mx-3 grey--text text--darken-1"
              for="url_img"
              v-if="!inputImageAlert"
              >Imagem do Banner:</span
            >
            <span
              class="subheading mx-3 grey--text text--darken-1"
              for="url_img"
              v-if="inputImageAlert"
            >
              Imagem de Banner:
              <span class="pl-2 error--text">(Campo Obrigatório)</span>
            </span>
            <div class="mx-3 mt-2">
              <image-uploader
                :maxWidth="512"
                :maxHeight="248"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                @input="onFileSelected"
                accept="image/*"
                doNotResize="['gif', 'svg']"
              ></image-uploader>
            </div>
            <br />
          </v-flex>
          <v-flex md6 xs12 class="pt-3">
            <span
              class="subheading mx-3 grey--text text--darken-1"
              for="url_img_details"
              v-if="!inputImageAlert"
              >Imagem de Detalhamento:</span
            >
            <span
              class="subheading mx-3 grey--text text--darken-1"
              for="url_img_details"
              v-if="inputImageAlert"
            >
              Imagem de Detalhamento:
              <span class="pl-2 error--text">(Campo Obrigatório)</span>
            </span>
            <div class="mx-3 mt-2">
              <image-uploader
                :maxWidth="512"
                :maxHeight="248"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                @input="onFileSelected2"
                accept="image/*"
                doNotResize="['gif', 'svg']"
              ></image-uploader>
            </div>
            <br />
          </v-flex>
          <v-layout
            align-center
            justify-start
            md1
            xs2
            v-if="!isRecurrentOrWalletHours() && promotion.type != 'loyalty'"
          >
            <span class="subheading ml-3 grey--text text--darken-1"
              >Tempo de uso:</span
            >
          </v-layout>
          <v-flex
            md2
            xs5
            v-if="!isRecurrentOrWalletHours() && promotion.type != 'loyalty'"
          >
            <v-text-field
              type="number"
              v-model="hours"
              class="mr-3"
              label="Horas"
              :rules="[
                v => !!v || 'Campo obrigatório!',
                v => v >= 0 || 'Valor inválido!',
              ]"
              v-mask="'########'"
            ></v-text-field>
          </v-flex>
          <v-flex
            md2
            xs5
            v-if="!isRecurrentOrWalletHours() && promotion.type != 'loyalty'"
          >
            <v-text-field
              type="number"
              v-model="minutes"
              class="mx-3"
              label="Minutos"
              :rules="[
                v => !!v || 'Campo obrigatório!',
                v => v >= 0 || 'Valor inválido!',
              ]"
              v-mask="'##'"
            ></v-text-field>
          </v-flex>
          <v-flex v-if="promotion.type == 'banner'" md6 xs6>
            <v-text-field
              v-model="promotion.url_redirect"
              class="mx-3"
              maxlength="250"
              counter
              label="Link de direcionamento do banner"
            ></v-text-field>
          </v-flex>
          <v-flex
            class="pt-4"
            v-if="!isRecurrentOrWalletHours() && promotion.type != 'loyalty'"
          >
            <span
              class="subheading mx-3 grey--text text--darken-1"
              for="url_img"
              v-if="!inputDaysAlert"
              >Dias da Semana: (em que a Oferta pode ser aplicada)</span
            >
            <span
              class="subheading mx-3 grey--text text--darken-1"
              for="url_img"
              v-if="inputDaysAlert"
            >
              Dias da Semana:
              <span class="pl-2 error--text">(Campo Obrigatório)</span>
            </span>
            <br />
          </v-flex>
          <v-container
            row
            class="pa-0 mx-3"
            v-if="!isRecurrentOrWalletHours() && promotion.type != 'loyalty'"
          >
            <v-checkbox
              v-model="promotion.valid_days.segunda"
              label="Segunda"
              class="mt-2"
            ></v-checkbox>
            <v-checkbox
              v-model="promotion.valid_days.terca"
              label="Terça"
              class="mt-2"
            ></v-checkbox>
            <v-checkbox
              v-model="promotion.valid_days.quarta"
              label="Quarta"
              class="mt-2"
            ></v-checkbox>
            <v-checkbox
              v-model="promotion.valid_days.quinta"
              label="Quinta"
              class="mt-2"
            ></v-checkbox>
            <v-checkbox
              v-model="promotion.valid_days.sexta"
              label="Sexta"
              class="mt-2"
            ></v-checkbox>
            <v-checkbox
              v-model="promotion.valid_days.sabado"
              label="Sábado"
              class="mt-2"
            ></v-checkbox>
            <v-checkbox
              v-model="promotion.valid_days.domingo"
              label="Domingo"
              class="mt-2"
            ></v-checkbox>
          </v-container>
        </v-form>

        <v-flex xs12 class="text-xs-right botao-final">
          <v-btn class="success white--text" @click="validate()"
            >Próxima Etapa</v-btn
          >
        </v-flex>
      </v-layout>

      <!-- Segunda etapa -->
      <span class="subheading font-weight-medium pl-4" v-if="value == 20"
        >Etapa {{ currentStep }} de {{ steps }} - Selecionar Clientes</span
      >
      <v-layout class="mx-1" row wrap v-if="value == 20">
        <v-flex xs12 class="my-4 mx-1">
          <v-data-table
            v-model="selectedClients"
            :headers="headersClient"
            :items="clients"
            item-key="id"
            color="red"
            :items-per-page="100000"
            :hide-default-footer="true"
            show-select
            no-data-text="Nenhum Cliente Cadastrado"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.nome_with_model">
                  <td>
                    <v-checkbox
                      v-model="selectedClients"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td></td>
                  <td class="text-right sortable">
                    {{ item.nome_with_model }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn
            class="grey white--text"
            @click="
              (value = 1), (ifImage = false);
              previous();
            "
            >Voltar</v-btn
          >
          <v-btn
            class="success white--text"
            :disabled="selectedClients.length == 0 ? true : false"
            @click="next(40)"
            >Próxima Etapa</v-btn
          >
        </v-flex>
      </v-layout>

      <!-- Complemtento da segunda caso oferta do tipo recorrente Etapa -->
      <span class="subheading font-weight-medium pl-4" v-if="value == 25"
        >Etapa {{ currentStep }} de {{ steps }} - Preço por Cliente</span
      >
      <v-layout class="mx-1" row wrap v-if="value == 25">
        <v-flex xs12 class="my-4 mx-1">
          <v-layout
            row
            wrap
            class="mx-3"
            v-for="(client, index) in selectedClients"
            :key="index"
            :value="client.id"
          >
            <v-flex xs12>
              <span class="font-weight-medium subheading">{{
                client.name
              }}</span>
            </v-flex>
            <v-flex xs12 md4 class="pr-2">
              <label for="model">Valor da ativação</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-model="client.activation_value"
                  v-bind="money"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
            <v-flex
              xs12
              md4
              class="pr-2"
              v-if="promotion.type != 'wallet_hours'"
            >
              <label for="model">Valor da mensalidade</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-model="client.recurring_payment_amount"
                  v-bind="money"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
            <v-flex xs12 md4 class="pr-2">
              <label for="model">Horas disponíveis por mês</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >H</span
                  >
                </div>
                <input
                  class="form-control"
                  type="number"
                  v-mask="'###'"
                  v-model="client.hours_per_month"
                />
              </div>
            </v-flex>
            <v-flex
              xs12
              md4
              class="pr-2"
              v-if="
                promotion.type == 'loyalty' || promotion.type == 'recurrent'
              "
            >
              <label for="model">Valor por km</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-model="client.price_km"
                  v-bind="money"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
            <!-- <v-flex xs12 md4 class="pr-2">
              <label for="model">Horas disponíveis por semana</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text font-weight-medium" id="basic-addon1">H</span>
                </div>
                <input
                  class="form-control"
                  type="number"
                  v-mask="'##'"
                  v-model="client.hours_per_week"
                />
              </div>
            </v-flex>-->
          </v-layout>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn
            class="grey white--text"
            @click="
              value = 20;
              previous();
            "
            >Voltar</v-btn
          >
          <v-btn
            class="success white--text"
            :disabled="false ? true : false"
            @click="
              value = 80;
              next();
            "
            >Próxima Etapa</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- Terceira Etapa -->
      <span class="subheading font-weight-medium pl-4" v-if="value == 40"
        >Etapa {{ currentStep }} de {{ steps }} - Selecionar Modelos</span
      >
      <v-layout class="mx-1" row wrap v-if="value == 40">
        <v-flex xs12 class="my-4 mx-1">
          <v-data-table
            v-model="selectedVehicleModels"
            :headers="headersVehicleModels"
            :items="vehicleModels"
            item-key="model"
            color="red"
            :items-per-page="100000"
            :hide-default-footer="true"
            show-select
            no-data-text="Nenhum Cliente Cadastrado"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.nome_with_model">
                  <td>
                    <v-checkbox
                      v-model="selectedVehicleModels"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td class="text-right sortable">{{ item.model }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn
            class="grey white--text"
            @click="
              value = 20;
              previous();
            "
            >Voltar</v-btn
          >
          <v-btn
            class="success white--text"
            :disabled="selectedVehicleModels.length == 0 ? true : false"
            @click="
              value = 60;
              next();
            "
            >Próxima Etapa</v-btn
          >
        </v-flex>
      </v-layout>

      <!-- Quarta Etapa -->
      <span class="subheading font-weight-medium pl-4" v-if="value == 60"
        >Etapa {{ currentStep }} de {{ steps }} - Valores por Modelo</span
      >
      <v-layout class="mx-1" row wrap v-if="value == 60">
        <!-- <v-switch v-model="samePrices" class="float" label="Mesmo valor para todos os modelos"></v-switch> -->

        <v-flex v-if="samePrices" xs12 class="my-4">
          <v-layout row wrap class="mx-3">
            <v-flex xs12>
              <span class="font-weight-medium subheading"
                >Todos os Modelos</span
              >
            </v-flex>
            <v-flex xs12 md4 class="pr-2" v-if="promotion.type == 'promotion'">
              <label for="model">Valor por hora</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money v-bind="money" class="form-control"></money>
              </div>
            </v-flex>
            <v-flex xs12 md4 class="pr-2" v-if="promotion.type == 'package'">
              <label for="model">Valor do pacote</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money v-bind="money" class="form-control"></money>
              </div>
            </v-flex>
            <v-flex xs12 md4>
              <label for="model">Valor por km</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-bind="money"
                  class="formselectedClients-control"
                ></money>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex v-if="!samePrices" xs12 class="my-4">
          <!-- Para cada Modelo -->
          <v-layout
            row
            wrap
            class="mx-3"
            v-for="(vehicleModel, index) in selectedVehicleModels"
            :key="index"
            :value="vehicleModel.id"
          >
            <v-flex xs12>
              <span class="font-weight-medium subheading">{{
                vehicleModel.model
              }}</span>
            </v-flex>
            <v-flex xs12 md4 class="pr-2" v-if="promotion.type == 'promotion'">
              <label for="model">Valor por hora</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-model="vehicleModel.hour_value"
                  v-bind="money"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
            <v-flex xs12 md4 class="pr-2" v-if="promotion.type == 'package'">
              <label for="model">Valor do pacote</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-model="vehicleModel.package_value"
                  v-bind="money"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
            <v-flex xs12 md4>
              <label for="model">Valor por km</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text font-weight-medium"
                    id="basic-addon1"
                    >R$</span
                  >
                </div>
                <money
                  v-model="vehicleModel.km_value"
                  v-bind="money"
                  class="form-control"
                ></money>
              </div>
            </v-flex>
            <!-- <v-divider class="mx-1 my-1"></v-divider> -->
          </v-layout>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn
            class="grey white--text"
            @click="
              value = 40;
              previous();
            "
            >Voltar</v-btn
          >
          <v-btn
            class="success white--text"
            @click="
              value = 80;
              next();
            "
            >Próxima Etapa</v-btn
          >
        </v-flex>
      </v-layout>

      <!-- Quinta Etapa -->
      <span class="subheading font-weight-medium pl-4" v-if="value == 80"
        >Etapa {{ currentStep }} de {{ steps }} - Revisão</span
      >
      <v-layout class="mx-1" row wrap v-if="value == 80">
        <v-flex xs12 md6 class="pt-4 px-2">
          <v-flex class="mb-2 text-justify">
            <span class="font-weight-medium subheading color">Título:</span>
            <span class="pl-2 subheading">{{ promotion.name }}</span>
          </v-flex>
          <v-flex class="mb-2 text-justify" v-if="promotion.type != 'banner'">
            <span class="font-weight-medium subheading color">Descrição:</span>
            <span class="pl-2 subheading">{{ promotion.sub_title }}</span>
          </v-flex>
          <v-flex class="mb-2 text-justify" v-if="promotion.type != 'banner'">
            <span class="font-weight-medium subheading color"
              >Termo de Uso:</span
            >
            <span class="pl-2 subheading text-justify">{{
              promotion.description
            }}</span>
          </v-flex>
          <v-flex class="mb-2 text-justify" v-if="promotion.type == 'banner'">
            <span class="font-weight-medium subheading color"
              >Url Redirect:</span
            >
            <span class="pl-2 subheading text-justify">{{
              promotion.url_redirect
            }}</span>
          </v-flex>
          <v-flex xs12 class="row px-3">
            <v-flex class="mb-2 text-justify">
              <span class="font-weight-medium subheading color"
                >Data Início:</span
              >
              <span class="pl-2 subheading">{{ promotion.start_date }}</span>
            </v-flex>
            <v-flex class="mb-2 text-justify">
              <span class="font-weight-medium subheading color">Data Fim:</span>
              <span class="pl-2 subheading">{{ promotion.end_date }}</span>
            </v-flex>
            <v-flex
              class="mb-2 text-justify"
              v-if="!isRecurrentOrWalletHours()"
            >
              <span class="font-weight-medium subheading color"
                >Tempo de uso:</span
              >
              <span class="pl-2 subheading"
                >{{ promotion.usage_time }} minutos.</span
              >
            </v-flex>
            <v-flex
              xs12
              class="mb-2 text-justify"
              v-if="!isRecurrentOrWalletHours()"
            >
              <span class="font-weight-medium subheading color pr-2"
                >Dias da semana:</span
              >
              <span
                v-for="(day, index) in selectedDays"
                :key="index"
                class="subheading"
                >{{ day }} -</span
              >
            </v-flex>
            <v-flex
              xs12
              class="mb-2 text-justify"
              v-if="promotion.type != 'banner'"
            >
              <span class="font-weight-medium subheading color pr-2"
                >Clientes:</span
              >
              <span
                v-for="(client, index) in selectedClients"
                class="subheading"
                :key="index"
                >{{ client.name }} -</span
              >
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex xs12 md6 class="pt-4 px-2 mb-2">
          <v-img max-height="220px" class="mx-3" :src="showImage"></v-img>
        </v-flex>

        <v-flex xs12 class="mb-3 px-2" v-if="!isRecurrentOrWalletHours()">
          <v-data-table
            :items="selectedVehicleModels"
            item-key="model"
            :headers="headersModelsPrices"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <td class="text-xs-left">{{ props.item.model }}</td>
                <td class="text-xs-left">{{ props.item.hour_value }}</td>
                <td class="text-xs-left">{{ props.item.package_value }}</td>
                <td class="text-xs-left">{{ props.item.km_value }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex
          xs12
          class="mb-3 px-2"
          v-if="isRecurrentOrWalletHours() && promotion.type != 'banner'"
        >
          <v-data-table
            :items="selectedClients"
            item-key="model"
            :headers="headersClientsPrices"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.activation_value }}</td>
                <td class="text-xs-left">
                  {{ props.item.recurring_payment_amount }}
                </td>
                <td class="text-xs-left">{{ props.item.hours_per_month }}</td>
                <td class="text-xs-left">{{ props.item.hours_per_week }}</td>
              </tr>
              selectedClients
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 class="mb-3 px-2" v-if="promotion.type == 'banner'">
          <v-data-table
            :items="selectedClients"
            item-key="model"
            :headers="headersBanner"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <td class="text-xs-left">{{ props.item.name }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn class="grey white--text" @click="previous(25)">Voltar</v-btn>
          <v-btn
            class="success white--text"
            :loading="createLoading"
            @click="createPromotion"
            >Cadastrar Oferta</v-btn
          >
        </v-flex>
      </v-layout>

      <span class="subheading font-weight-medium pl-4" v-if="value == 100"
        >Oferta cadastrada com sucesso!!</span
      >

      <v-layout class="mx-1" row wrap v-if="value == 100">
        <v-flex xs12 class="text-xs-right pt-3">
          <v-btn class="success white--text" @click="$emit('close'), clear()"
            >OK</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientController from '../../controllers/ClientController';
import DiscountTypeController from '../../controllers/DiscountTypeController';
import VehicleModelController from '../../controllers/VehicleModelController';
import PromotionController from '../../controllers/PromotionController';
import VehicleCategoryController from '../../controllers/VehicleCategoryController.js';
import Promotion from '../../models/Promotion';
import moment from 'moment';

export default {
  props: {
    newPromotion: Boolean,
  },
  data() {
    return {
      promotion: new Promotion(),
      clientController: new ClientController(this.$resource),
      discountTypeController: new DiscountTypeController(this.$resource),
      vehicleModelController: new VehicleModelController(this.$resource),
      vehicleCategoryController: new VehicleCategoryController(this.$resource),
      promotionController: new PromotionController(this.$resource),
      headersClient: [
        { text: '', value: 'checkbox', sortable: false },
        { text: 'Condomínio', align: 'right', value: 'name' },
      ],
      headersVehicleModels: [
        { text: 'Modelo', align: 'right', value: 'model' },
      ],
      headersModelsPrices: [
        { text: 'Modelo', align: 'left', value: 'model' },
        { text: 'Preço por Hora', align: 'left', value: 'hour_value' },
        { text: 'Preço no Pacote', align: 'left', value: 'package_value' },
        { text: 'Preço por Km', align: 'left', value: 'km_value' },
      ],
      headersClientsPrices: [
        { text: 'Cliente', align: 'left', value: 'name' },
        {
          text: 'Valor da ativação',
          align: 'left',
          value: 'activation_value',
        },
        {
          text: 'Valor Mensal',
          align: 'left',
          value: 'recurring_payment_amount',
        },
        {
          text: 'Horas disponíveis por mês',
          align: 'left',
          value: 'hours_per_month',
        },
        {
          text: 'Horas disponíveis por semana',
          align: 'left',
          value: 'hours_per_week',
        },
      ],
      headersBanner: [{ text: 'Cliente', align: 'left', value: 'name' }],
      value: 1,
      category: {},
      rules: {
        required: value => !!value || 'Campo Obrigatório',
        counterTitle: value => value.length <= 20 || 'Max 20',
        counterUrlRedirect: value => value.length <= 250 || 'Max 200',
        counterSubtitle: value => value.length <= 30 || 'Max 30',
        counterDescription: value => value.length <= 250 || 'Max 250',
      },
      data: new FormData(),
      valid: true,
      menuInicio: false,
      menuFim: false,
      selectedClients: [],
      clients: [],
      discountsTypes: [],
      selectedVehicleModels: [],
      vehicleModels: [],
      samePrices: false,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      modelsPrices: [],
      ifImage: false,
      inputImageAlert: false,
      inputDaysAlert: false,
      selectedDays: [],
      showImage: null,
      createLoading: false,
      hours: null,
      minutes: null,
      steps: 5,
      currentStep: 1,
    };
  },
  created() {
    this.getCategory();
    this.getClients();
    this.getDiscountType();
  },
  methods: {
    next(stepValue) {
      if (stepValue) {
        if (this.isRecurrentOrWalletHours() && this.promotion.type != 'banner')
          this.value = 25;
        else if (this.promotion.type == 'banner') this.value = 80;
        else this.value = stepValue;

        if (stepValue == 40) this.getVehicleModels();
      } else {
        this.getClients();
      }
      this.currentStep += 1;
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    previous(stepValue) {
      if (stepValue) {
        if (this.isRecurrentOrWalletHours()) this.value = 25;
        else this.value = stepValue;
      }
      this.currentStep -= 1;
    },
    setSteps() {
      if (this.promotion.type == 'loyalty') {
        this.promotion.vehicles_model_category = 0;
        this.steps = 4;
      } else this.promotion.vehicles_model_category = 1;

      if (this.promotion.type == 'recurrent') this.steps = 4;
      if (this.promotion.type == 'banner') this.steps = 3;
      else this.steps = 5;
    },
    getClients() {
      this.clientController
        .getAllClientsWithVehicleModel(this.promotion.vehicles_model_category)
        .then(clients => {
          this.clients = clients;
        });
    },
    async getDiscountType() {
      await this.discountTypeController
        .getDiscountType()
        .then(discountsTypes => {
          this.discountsTypes = discountsTypes.body;
        });
    },
    getCategory() {
      this.vehicleCategoryController.getAll().then(res => {
        this.category = res;
      });
    },
    getVehicleModels() {
      let data = this.selectedClients.map(obj => obj.id);
      this.vehicleModelController
        .getAllByListId(data.join(', '), this.promotion.vehicles_model_category)
        .then(vehicleModels => (this.vehicleModels = vehicleModels));
    },
    isRecurrentOrWalletHours() {
      if (
        this.promotion.type == 'recurrent' ||
        this.promotion.type == 'loyalty' ||
        this.promotion.type == 'wallet_hours' ||
        this.promotion.type == 'banner'
      )
        return true;
      else return false;
    },
    createPromotion() {
      this.createLoading = true;
      this.promotion.promotionClients = this.selectedClients;
      this.promotion.promotionVehicleModels = this.selectedVehicleModels;
      this.data.append('form', JSON.stringify(this.promotion));
      this.promotionController.create(this.data).then(
        res => {
          this.createLoading = false;
          this.value = 100;
          this.promotion = new Promotion();
        },
        err => {
          this.$awn.alert(err);
          this.createLoading = false;
          this.data.delete('form');
        }
      );
    },

    clear() {
      this.value = 1;
      this.menuInicio = false;
      this.menuFim = false;
      this.promotion = new Promotion();
      this.ifImage = false;
      this.selectedClients = [];
      this.selectedVehicleModels = [];
      this.selectedDays = [];
      this.showImage = null;
      this.hours = null;
      this.minutes = null;
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },

    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    async onFileSelected(event) {
      this.data = new FormData();

      this.inputImageAlert = false;
      this.showImage = event.dataUrl;
      let img = this.dataURLtoFile(event.dataUrl, event.info.name);

      if (img) {
        this.ifImage = true;
        this.data.append(img.name, img);
      }
    },

    async onFileSelected2(event) {
      this.inputImageAlert = false;
      this.showImage = event.dataUrl;
      let img = this.dataURLtoFile(event.dataUrl, event.info.name);

      if (img) {
        this.ifImage = true;
        this.data.append(img.name, img);
      }
    },

    validate() {
      let ret = false;
      this.selectedDays = [];
      let h = this.hours * 60;

      this.promotion.usage_time = parseInt(h) + parseInt(this.minutes);

      Object.values(this.promotion.valid_days).forEach(day => {
        if (day) {
          ret = true;
        }
      });

      for (var [key, value] of Object.entries(this.promotion.valid_days)) {
        if (value) {
          if (key == 'terca') this.selectedDays.push('terça');
          else if (key == 'sabado') this.selectedDays.push('sábado');
          else this.selectedDays.push(key);
        }
      }

      if (this.$refs.form.validate() && this.ifImage && ret) {
        this.value = 20;
        this.next();
      }

      this.ifImage
        ? (this.inputImageAlert = false)
        : (this.inputImageAlert = true);
      ret ? (this.inputDaysAlert = false) : (this.inputDaysAlert = true);
    },
  },
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 85px;
  right: 40px;
}

.botao-final {
  margin-top: 10px;
  margin-bottom: 10px;
}

.radio-row {
  display: block;
  /* margin-bottom: 5px; */
}
.color {
  color: var(--secondary-color);
}
</style>
